import { sanitizeRichHtml } from "@lib/sanitizeHtml"
import { careersTransitionName } from "@lib/viewTransitions"
import type { CareerItem } from "@site-types/content"
import { useRouteShellContext } from "@components/routeShellContext"
import { AstroTransitionLink } from "../../AstroTransitionLink"
import { imageAlt, imageRenderProps, imageTitle } from "../../componentUtils"
import OptimizedImage from "../../OptimizedImage"
import "./styles.css"

export function CareersCard({
  position,
  priority = false,
}: { position: CareerItem
  priority?: boolean
}) {
  const { locale } = useRouteShellContext()
  if (!position.newsCoverImage) return null
  const transitionName = careersTransitionName(position.slug?.current ?? "")
  return (
    <li
      className="position"
      data-content-transition-element="true"
      data-content-transition-name={transitionName}
      data-id={`career-card-${position.slug?.current ?? "unknown"}`}
    >
      <AstroTransitionLink
        to={`/${locale}/careers/${position.slug?.current}`}
        className="image"
        aria-label={position.title}
        data-id={`career-card-link-${position.slug?.current ?? "unknown"}`}
        transitionName={transitionName}
      />
      <OptimizedImage
        title={imageTitle(position.newsCoverImage, locale)}
        alt={imageAlt(position.newsCoverImage, locale)}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        fetchPriority={priority ? "high" : "auto"}
        {...imageRenderProps(position.newsCoverImage, "careerCard")}
      />
      <h4>{position.title}</h4>
      <h5 dangerouslySetInnerHTML={{ __html: sanitizeRichHtml(position.teamName) }} />
    </li>
  )
}

export default CareersCard
